<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                :disabled="disabled"
                @click="$emit('click')"
                type="button"
                aria-label="Сохранить поиск в избранное"
                small
                outlined
                color="primary"
                class="mr-2 favorite-search-button"
                min-width="40"
            >
                <favorite-search-icon />
            </v-btn>
        </template>
        <span>Сохранить поиск в избранное</span>
    </v-tooltip>
</template>

<script>
import FavoriteSearchIcon from './FavoriteSearchIcon.vue'

export default {
    name: 'FavoriteSearchButton',
    components: {FavoriteSearchIcon},
    props: {disabled: Boolean},
}
</script>

<style scoped>
.favorite-search-button {
    padding: 0 8px !important;
}
</style>
